import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const [sp] = useSearchParams();
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = sp.get("token");
    const onboarded = sp.get("onboarded") === "1";
    if (!token) {
      toast.error("Authentication failed");
      navigate("/auth");
      return;
    }
    localStorage.setItem("token", token);
    refresh().then(() => {
      toast.success("Signed in!");
      navigate(onboarded ? "/dashboard" : "/onboarding");
    });
  }, [sp, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
      <div className="text-center">
        <div className="inline-block h-8 w-8 border-2 border-slate-300 border-t-[#0047FF] rounded-full animate-spin" />
        <p className="mt-4 text-slate-600">Completing sign-in…</p>
      </div>
    </div>
  );
}
